import React, { FC, useContext } from "react"

import { ICard } from "../../../../../interfaces";
import frontSideAction from "../../../../../assets/cards/action.svg";

import { CardContext, TeamContext, UserContext } from "../../../../../context";
import { SwapCardButton } from "../../../../molecules";

interface ChallengeCardProps {
    cardData: ICard;
}

const ActionCard: FC<ChallengeCardProps> = ({ cardData }) => {
    const { game } = useContext(TeamContext);
    const { userData } = useContext(UserContext);
    const { setIsExchangeButtonOnActionHovered } = useContext(CardContext);
    const isTheUserDilemaOwner = userData?.email === game?.gameInfo.currentPlayerEmail;

    const renderChallengeCardTypes = () => {
        return (
            <div className="front_side_action" >
                <img className="front_side_action_image" src={frontSideAction} alt="front side action" />
                <div className="front_side_action_text">
                    {isTheUserDilemaOwner && 
                        <div 
                            onMouseEnter={() => setIsExchangeButtonOnActionHovered(true)}
                            onMouseLeave={() => setIsExchangeButtonOnActionHovered(false)}
                        >  
                            <SwapCardButton cardType="challenge" /> 
                        </div>
                    }
                    <p className="front_side__challenge_title">{cardData.title}</p>
                    <p className="front_side__challenge_content">{cardData.content}</p>
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            {renderChallengeCardTypes()}
        </React.Fragment>
    );
}

export default ActionCard;